import ListViewRightPart from '../../components/CountryComponent/ListViewRightPart/ListViewRightPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(ListViewRightPart);
